import {Bar, BarChart, CartesianGrid, Cell, ResponsiveContainer, Tooltip, XAxis, YAxis} from "recharts";
import React from "react";
import {IPollResult} from "../types/poll.types";

interface IPollResultGraphProps {
    result: IPollResult | undefined;
}

const PollResultGraph = (props: IPollResultGraphProps) => {
    const colors = [
        "#7C3AED",
        "#06B6D4",
        "#10B981",
        "#F59E0B",
        "#EF4444",
        "#3B82F6",
    ];

    return (
        <div className={'result-graph'}>
            <div className={'heading'}>VOTE DISTRIBUTION</div>
            <ResponsiveContainer width="100%" height={240}>
                <BarChart
                    data={props.result?.options ?? []}
                    margin={{top: 8, right: 8, left: -30, bottom: 0}}
                    barSize={30}
                >
                    <CartesianGrid stroke="#F3F4F6" strokeDasharray="3 3" vertical={false}/>
                    <XAxis
                        dataKey="option"
                        // interval={0}
                        // angle={-25}
                        // textAnchor="end"
                        // height={70}
                    />

                    <YAxis/>

                    <Tooltip/>

                    <Bar
                        dataKey="votePercentage"
                        name="Vote %"
                        radius={[4, 4, 0, 0]}
                    >
                        {props.result?.options.map((item, index) => (
                            <Cell
                                key={item.optionId}
                                fill={colors[index % colors.length]}
                            />
                        ))}
                    </Bar>
                </BarChart>
            </ResponsiveContainer>
        </div>
    )
}

export default PollResultGraph